// @ts-nocheck
import {getLocale} from 'acng/locale/model/locale.js';

angular.module('userPool').factory('userPoolApi', ['$rootScope', 'http', '$translate', function ($rootScope, http, $translate) {
  var qGetProfile;
  return {
    resetPassword: function (formData) {
      return http().post('api/user/reset-password', $.param(formData));
    },
    updatePassword: function (data) {
      return http().put('api/user/update-password', data, { dontIntercept: true });
    },
    getProfile: function () {
      if (qGetProfile) return qGetProfile;
      qGetProfile = http().get('api/userProfile/view');
      qGetProfile.finally(function () {
        qGetProfile = null;
      });
      return qGetProfile;
    },
    updateProfile: function (profile) {
      return http().put('api/userProfile/update', profile, { dontIntercept: true });
    },
    uploadImage: function (image) {
      return http().post('api/userProfile/image', image, {
        dontIntercept: true,
        transformRequest: angular.identity,
        headers: { 'Content-Type': undefined }
      });
    },
    getWaitingImages: function () {
      return http().get('/api/userProfile/waiting-images');
    },
    deactivate: function () {
      return http().post('/api/user/deactivate');
    },
    translations: function () {
      return http().get(`/language/${getLocale()}/models.UserProfile`);
    },
    rename: function (nickname) {
      return http().post('/api/user/rename', $.param({ 'nickname': nickname }));
    },
    changeEmail: function (email) {
      return http().post('/api/user/change-email', $.param({ 'email': email }));
    },
    deleteSafely: function () {
      return http().delete('/api/user', { dontIntercept: true });
    }
  };
}]);
